<template>
    <div class="inOtherDetailBox">
            <div class="wrapper">
                <div class="inOtherDetail">
                        <div class="insearchbox">
                            <input class="searchInput" placeholder="keywords" v-model="key" />
                            <button type="submit" class="searchSubmit" @click="searchData()">{{isZhong?'搜索':'SEARCH'}}</button>
                        </div>
                    <div class="insearchList">
                        <ul v-if="searchList && searchList.length>0">
                            <li v-for="(item,index) in searchList" :key="item.contentid">
                                <div class="num">{{index+1}}.</div>
                                <div class="column">Column</div>
                                <div class="line"></div>
                                <div class="title"><router-link :to='`/products/productdetail/${item.contentid}`'>{{item.title}}</router-link></div>
                            </li>
                           
                        </ul>
                        <div class="searchNoData" v-else>
                            <div class="img"><img src="./images/beijing_search.jpg" /></div>
                            <div class="text">
                                <template v-if="isZhong">
                                    暂无搜索结果
                                </template>
                                <template v-else>
                                    What keywords are you searching for?<br>
                                    There is nothing at all!
                                </template>
                                
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        </div>
</template>

<script>
import { getSearch } from '../../../api'

export default {
    data() {
        return {
            title:'',
            searchList:[],
			key:'',
            isZhong:false
        };
    },
     created(){
       const language = this.$cookies.get('language');
       let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong; 
        let positionInfo ={};
        if(isZhong){
            positionInfo={
                second:'搜索',
                third:''
            }
        }else{
            positionInfo={
                second:'SITE SEARCH',
                third:''
            }
        }

        const bannerUrl = './static/images/banner_search.jpg';
        this.title = positionInfo.second;                       
        this.$emit('sendBanner', {bannerUrl,positionInfo});

        //search
		this.searchData();
        
    },
	methods:{
		async searchData(){
			let data={}
			const res = await getSearch(this.key,data);
			const searchList = res.data;
			this.searchList = searchList;
			
		}
	}
   
};
</script>
<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inOtherDetailBox {
   background: #fafdfd;  
   padding: 28px 0 66px 0;
}
.inOtherDetail {
  padding: 66px 50px 78px 50px;
  background: #fff;
  
    .insearchbox {
        width: 100%;
        height: 136px;
        background: #f5f5f5;
        display: flex;
        align-items: center;
      .searchInput {
          width: 345px;
          height: 45px;
          display: block;
          border: 1px solid #ccc;
          margin-left: 45px;
          margin-right: 10px;
          font-size: 12px;
          background: #fff;
          line-height: 45px;
          text-indent: 18px;
      }
      .searchSubmit {
          width: 106px;
          height: 45px;
          display: block;
          border: 1px solid #ccc;
          text-align: center;
          font-size: 12px;
          background: #fff;
          line-height: 45px;
          cursor: pointer;
      }
    }
  

  .insearchList {
    min-height: 298px;  
    ul {
      margin-top: 26px;  
      li {
        line-height: 58px;
        height: 58px;
        overflow: hidden;
        margin-top: 12px;  
        border-bottom: 1px solid #f5f5f5;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .num {
            width: 22px;
        }
        .column {
            width: 92px;
        }
        .line {
            width:1px;
            height: 24px;
            background: #ccc;

        }
        .title {
            margin-left: 60px;
            flex: 1;
            height: 100%;
            overflow: hidden;

        }
      }
    }
  }
}
.searchNoData{
    padding: 100px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img,view{
        max-width: 100%;
    }
    .text{
        margin-top: 36px;
        line-height: 30px;
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Other/Search/Search.vue